import { DefaultPageSkeleton } from '@/components/ui/default-page-skeleton'

export const CreatorsPageSkeleton = () => {
  return <DefaultPageSkeleton />
}
